import { render, staticRenderFns } from "./FlockReportDrilldown.vue?vue&type=template&id=1286c0fd&scoped=true&"
import script from "./FlockReportDrilldown.vue?vue&type=script&lang=js&"
export * from "./FlockReportDrilldown.vue?vue&type=script&lang=js&"
import style0 from "./FlockReportDrilldown.vue?vue&type=style&index=0&id=1286c0fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1286c0fd",
  null
  
)

export default component.exports